import type { PortalContext } from '../lib/types'

export type Phase = 'loading' | 'landing' | 'form' | 'submitted' | 'closed' | 'no_cycle' | 'error'

/**
 * The first page the portal shows for a context. A hard-close cycle past its deadline
 * shows the closed page, or the status page when the organisation submitted.
 */
export function portalPhaseFor(ctx: Pick<PortalContext, 'cycle' | 'submission'>): Phase {
  if (!ctx.cycle) return 'no_cycle'
  if (ctx.cycle.closedOn) return ctx.submission ? 'submitted' : 'closed'
  return ctx.submission && ['submitted', 'amended'].includes(ctx.cycle.status) ? 'submitted' : 'landing'
}

/** The sentence for a request that closed at its deadline. */
export function closedMessage(closedOn: string): string {
  return `This request closed on ${closedOn}.`
}

/**
 * True for a phase that shows the "Start an update" control. A person can start a
 * voluntary update when no request is open, and also after a request closed at its deadline.
 */
export function offersSelfServeStart(phase: Phase): boolean {
  return phase === 'no_cycle' || phase === 'closed'
}
